import { cn, V2Button } from "@stacklet/ui";
import { useNavigate } from "react-router";

import { StatusIcon } from "../icons/StatusIcon";

interface Props {
  resetErrorBoundary(): void;
  goBack?: boolean;
  tryAgain?: boolean;
  message?: string | undefined;
  height?: number | string;
  heading?: boolean;
  border?: boolean;
}

export function ErrorFallback({
  resetErrorBoundary,
  goBack = true,
  tryAgain = false,
  message,
  height,
  heading = true,
  border,
}: Props) {
  const navigate = useNavigate();

  const errorMessage =
    message || "Something went wrong. Please try again later.";

  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center",
        border ? "m-1 rounded-1 p-6 ring-1 ring-legacy-navy-L80" : "",
      )}
      style={{ minHeight: height ?? "100vh" }}
    >
      {heading ? (
        <div className="mb-1 text-[4.5rem] font-bold">Error</div>
      ) : null}
      <div className="mb-8">
        <div className="inline-flex items-center text-label-large">
          <StatusIcon status="error" />
          <span>{errorMessage}</span>
        </div>
      </div>
      {tryAgain ? (
        <V2Button onPress={resetErrorBoundary} variant="primary">
          Try again?
        </V2Button>
      ) : null}
      {goBack && !tryAgain ? (
        <V2Button onPress={() => navigate(-1)} variant="primary">
          Go back
        </V2Button>
      ) : null}
    </div>
  );
}
